import Body from './body'
import Title from './title'
import H3 from './h3'
export const CustomTypography = {
  Body,
  Title,
  H3
}
